import { Box, Slider, useTheme } from "@mui/material";

interface IBybVrSlider {
  value: number;
  onChange: (event: Event, newValue: number | number[]) => void;
  min?: number;
  max?: number;
  step?: number | null;
  marks?: boolean | Array<{ value: number; label?: string }>;
  disabled?: boolean;
}

const BybVrSlider = ({ value, onChange, min = 0, max = 100, step = 1, marks, ...props }: IBybVrSlider) => {
  const theme = useTheme();

  return (
    <Box boxSizing={"border-box"} paddingX={2}>
      <Slider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        marks={marks}
        {...props}
        sx={{
          color: theme.palette.success.main,
          "& .MuiSlider-track": {
            backgroundColor: theme.palette.success.main,
            height: theme.spacing(3),
            borderRadius: theme.spacing(2),
            paddingX: theme.spacing(1.65),
            transform: `translate(${theme.spacing(-1.75)}, ${theme.spacing(-1.6)})`,
          },
          "& .MuiSlider-rail": {
            backgroundColor: theme.palette.dsSurface.v500,
            opacity: 1,
            height: theme.spacing(3.325),
            borderRadius: theme.spacing(2),
            paddingX: theme.spacing(1.75),
            transform: `translate(${theme.spacing(-1.75)}, ${theme.spacing(-1.6)})`,
          },
          "& .MuiSlider-thumb": {
            backgroundColor: theme.palette.common.white,
            width: theme.spacing(2.5),
            height: theme.spacing(2.5),
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            "&:hover, &.Mui-focusVisible": {
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            },
            "&.Mui-active": {
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            },
          },
          "& .MuiSlider-mark": {
            backgroundColor: theme.palette.text.secondary,
            width: theme.spacing(0.25),
            height: theme.spacing(1.5),
            borderRadius: "1px",
            "&.MuiSlider-markActive": {
              backgroundColor: theme.palette.success.main,
            },
          },
          "& .MuiSlider-markLabel": {
            color: theme.palette.text.secondary,
            fontSize: theme.typography.caption.fontSize,
            fontWeight: 500,
            marginTop: theme.spacing(0.5),
          },
        }}
      />
    </Box>
  );
};

export default BybVrSlider;
